import { Document, Page, pdfjs } from "react-pdf";
import { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
pdfjs.GlobalWorkerOptions.workerSrc =
    window.location.origin + "/pdf.worker.min.js";

const PdfViewer = ({ fileUrl }) => {
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    useEffect(() => {
        if (fileUrl) {
            setPageNumber(1)
            //setNumPages(null);
        }
    }, [fileUrl])

    return (
        <>
            <Box
                sx={{
                    height: 550,
                    overflow: "auto",
                    border: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "flex-start",
                    p: 2,
                    bgcolor: "#f5f5f5",
                    "& canvas": {
                        display: "block",
                        margin: "0 auto",
                    },
                }}
            >
                <Document
                    file={fileUrl}
                    onLoadSuccess={onDocumentLoadSuccess}
                >
                    <Page
                        pageNumber={pageNumber}
                        width={420}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                    />
                </Document>
            </Box>

            <Box sx={{ py: 1, textAlign: "center" }}>
                <IconButton
                    disabled={pageNumber <= 1}
                    onClick={() => setPageNumber((p) => p - 1)}
                >
                    <ArrowBackIcon />
                </IconButton>

                Page {pageNumber} of {numPages}

                <IconButton
                    disabled={pageNumber >= numPages}
                    onClick={() => setPageNumber((p) => p + 1)}
                >
                    <ArrowForwardIcon />
                </IconButton>
            </Box>
        </>
    );
};

export default PdfViewer;
